<template>
  <section id="gallery" ref="gallery">
    <aha-gallery :year="year" :active="active" :images="images" @close="active = false" />
    <div class="big spacer nb half">
      <div class="title mbig pb bb">{{ gallery.title }}</div>
      <div v-for="year in gallery.children" :key="year.uid" class="pt pb bb" @click="openGallery(year)">
        <span class='linktype'>{{ year.title }}</span>
      </div>
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
import AhaGallery from "@/components/AhaGallery.vue";
export default {
  components: {
    AhaGallery
  },
  data() {
    return {
      gallery: [],
      loaded: false,
      active: false,
      year: null,
      images: [],
    };
  },
  watch: {
    $route() {
      API.gallery(this.$i18n.locale).then(page => {
        this.gallery = page.data.result;
      });
    }
  },
  created() {
    API.gallery(this.$i18n.locale).then(page => {
      this.gallery = page.data.result;
      this.loaded = true;
    });
  },
  mounted() {
    if (this.$route.params.pathMatch == "gallery") {
      if (this.loaded) {
        this.$scrollTo("#" + this.$route.params.pathMatch, 1000);
      }
    }
  },
  methods: {
    openGallery(year) {
      this.active = true;
      this.images = year.images;
      this.year = year.uid;
    }
  }
};
</script>
